const styles = theme => {
    const underlineColor = theme.palette.secondary.main
    return {
        appBar: {
            display: 'flex',
            height: '72px',
            maxHeight: theme.spacing(9),
            position: 'fixed',
            transition: theme.transitions.create([ 'margin', 'width' ], {
                duration: theme.transitions.duration.leavingScreen,
                easing: theme.transitions.easing.sharp,
            }),
        },
        appBarShift: {
            transition: theme.transitions.create([ 'margin', 'width' ], {
                duration: theme.transitions.duration.enteringScreen,
                easing: theme.transitions.easing.easeOut,
            }),
        },
        arrow: {
            color: '#6F6F6F',
            fontFamily: 'material Regular',
            fontSize: '24px',
            letterSpacing: 0,
            lineHeight: 0,
        },
        arrowDropDown: {
            borderRadius: '2px',
            fontFamily: 'Roboto',
            fontSize: '14px',
            letterSpacing: '0',
            marginTop: '8px',
            padding: '16px 0px',
            textAlign: 'center',
            width: '100%',
        },
        avatar: {
            background: theme.palette.primary.main,
            fontFamily: 'Roboto',
            fontWeight: 500,
            height: theme.spacing(4),
            width: theme.spacing(4),
        },
        button: {
            '&.MuiButton-root': {
                borderRadius: '4px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                fontSize: '16px',
                height: '40px',
                letterSpacing: '0.5px',
                marginBottom: '15px',
                minWidth: '80px'
            }
        },
        dropdown: {
            height: '142px',
            padding: 0,
            width: '286px'
        },
        email: {
            color: theme.palette.primary.main,
            textDecoration: 'none',
        },
        firstName: {
            color: '#6F6F6F',
            fontFamily: 'Roboto',
            fontSize: '12px',
            letterSpacing: 0,
            lineHeight: '72px',
            textAlign: 'right',
        },
        firstNameHidden: {
            [theme.breakpoints.down('xs')]: {
                visibility: 'hidden'
            },
            [theme.breakpoints.down('321')]: {
                width: '0px'
            },
        },
        group: {
            [theme.breakpoints.down('321')]: {
                marginLeft: '5px'
            },
            marginLeft: 'auto'
        },
        hide: {
            display: 'none',
        },
        hr: {
            border: '1px solid rgba(0,0,0,0.12)',
            margin: 0,
            width: '100%'
        },
        languageButton: {
            color: 'rgb(0, 81, 165)',
            float: 'right',
            margin: '10px',
            width: '120px',
        },
        logoContainer: {
            alignItems: 'center',
            background: theme.palette.primary.contrastText,
            borderBottomLeftRadius: '35px 15px',
            borderBottomRightRadius: '35px 15px',
            display: 'flex',
            height: '91px',
            justifyContent: 'center',
            marginLeft: '48px',
            paddingTop: '14px',
            width: '69.23px',
        },
        logoEn: {
            marginLeft: '70px'
        },
        logoFr: {
            marginLeft: '99px'
        },
        menuButton: {
            '& > * > * > *': {
                height: '16px',
                width: '24px'
            },
            boxShadow: 'none',
            color: '#0069c3',
            height: '32px',
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            width: '32px'
        },
        menuButtonMobile: {
            marginLeft: theme.spacing(0)
        },
        menuContainer: {
            height: '100%',
        },
        menuContent: {
            color: theme.palette.text.secondary,
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '19px',
            padding: '4px 1px',
            textDecoration: 'none'
        },
        menuGroup: {
            height: '100%',
            marginLeft: 'auto'
        },
        menuItem: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            padding: 0
        },
        menuList: {
            '& > *': {
                padding: '0px 0px 0px 0px'
            },
        },
        menuNav: {
            margin: '0px 19.5px'
        },
        menuUnderline: {
            '& > a': {
                color: theme.palette.text.primary,
            },
            borderBottom: `3px solid ${underlineColor}`,
            height: '100%',
            width: 'fit-content'
        },
        navPopove: {
            height: '147px',
            width: '200px'
        },
        noPadding: {
            padding: '0px'
        },
        profileInfo: {
            alignItems: 'flex-start',
            display: 'flex',
            flexDirection: 'column',
            padding: '20px',
        },
        root: {
            display: 'flex',
            paddingBottom: '73px'
        },
        seperator: {
            background: '#dadada',
            borderBottom: '1px solid black',
            height: '1px',
            opacity: 0.12,
            position: 'absolute',
            width: theme.spacing(35)
        },
        seperatorSmallDevice: {
            [theme.breakpoints.down('xs')]: {
                width: 'calc(100%)',
            },
        },
        signOutButton: {
            alignItems: 'flex-start',
            boxShadow: 'none',
            display: 'flex',
            flexDirection: 'column',
            padding: '20px',
        },
        signOutLink: {
            color: theme.palette.text.primary,
            textDecoration: 'none',
        },
        subMenu: {
            '& > *': {
                background: 'inherit',
            }
        },
        title: {
            alignItems: 'center',
            color: '#0051A5',
            display: 'flex',
            fontFamily: 'RBCDisplay Regular',
            fontSize: '26px',
            height: '100%',
            letterSpacing: '-0.65px',
            lineHeight: '31px',
            paddingTop: '10px'
        },
        titleShift: {
            [theme.breakpoints.down('xs')]: {
                marginLeft: '0px'
            },
            marginLeft: '48px'
        },
        toolbar: {
            alignItems: 'center',
            display: 'flex',
            height: 'inherit',
            justifyContent: 'space-between',
            paddingRight: '64px',
        },
        toolbarMobile: {
            paddingRight: '16px'
        },
        toolbarProfile: {
            marginLeft: '117.5px'
        },
        ultraSmall: {
            width: '15px'
        },
        userName: {
            fontFamily: 'Roboto',
            fontWeight: 500,
        }
    }
}

export default styles
